// @flow
import * as React from 'react'
import styled, { css } from 'styled-components'

import colors from '../../styles/colors'

const RequirementList = ({
  error,
  passwordEmpty,
  password,
  requirements,
  value,
}) => {
  const passwordsMatches = () => {
    if (passwordEmpty) return 'unknown'
    else if (value === password) return 'fulfilled'
    else return 'error'
  }
  return (
    <RequirementsWrapper>
      {requirements.map((requirement) => {
        let status
        if (passwordEmpty) status = 'unknown'
        else if (error && error.includes(requirement)) status = 'error'
        else status = 'fulfilled'

        return (
          <Requirement key={requirement} status={status}>
            {requirementsNames[requirement]}
          </Requirement>
        )
      })}
      <Requirement status={passwordsMatches()}>
        {`${'podane hasła są zgodne'}`}
      </Requirement>
    </RequirementsWrapper>
  )
}

const requirementsNames = {
  tooShort: 'co najmniej 6 znaków',
  noUppercase: 'co najmniej jedna wielka litera',
  noLowercase: 'co najmniej jedna mała litera',
  noNumber: 'co najmniej jedna cyfra',
  noSpecialChar: 'co najmniej jeden znak specjalny !@#$%^&*(),.?":{}|<>',
}

const RequirementsWrapper = styled.ul`
  width: 100%;
`

const Requirement = styled.li`
  font-size: 0.6rem;
  line-height: 0.6rem;
  text-align: left;
  position: relative;
  text-indent: 1rem;
  margin-bottom: 0.6rem;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 6px;
    width: 2px;
    height: 2px;
    border-radius: 100%;
  }
  ${(props) => statusStyles[props.status]};
`

const statusStyles = {
  unknown: css`
    color: #9b9b9b;
    &:before {
      background: #9b9b9b;
    }
  `,
  error: css`
    color: ${colors.red};
    &:before {
      background: ${colors.red};
    }
  `,
  fulfilled: css`
    color: #54b386;
    &:before {
      top: 2px;
      width: 4px;
      height: 8px;
      border: solid #54b386;
      border-width: 0 1px 1px 0;
      border-radius: 0;
      transform: rotate(45deg);
    }
  `,
}

export default RequirementList
